import React from 'react';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
//UI
import { Collapse } from 'react-collapse';
import { FaLevelUpAlt, FaList, FaShip, FaUsers } from 'react-icons/fa';
import BtnDashboard from '../buttons/BtnDashboard';
//RESOURCERS
import { useToolbarStore } from '../../store/VitalStore';
import { FaGears } from "react-icons/fa6";
import school from '../../assets/icons/school.svg'
import users from '../../assets/icons/users.svg'
const AdminList = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { closeToolbar } = useToolbarStore((state) => state);

    return (
        <div className='w-[100%]'>
            <div className='pl-2 text-[10px] font-semibold uppercase text-start text-sky-700'>{t("administration_tag")}</div>
            <li
                onClick={(e) => { navigate('/panel/configurations'); closeToolbar(); }}
                className={`w-full ${location.pathname.startsWith('/panel/configurations') ? 'active' : ''}`}>
                <BtnDashboard>
                    <img src={school} className='w-6 h-6' />
                    <p>{t("Configuraciones")}</p>
                </BtnDashboard>
            </li>
            <li
                onClick={(e) => { navigate('/panel/users'); closeToolbar(); }}
                className={`w-full ${location.pathname.startsWith('/panel/users') ? 'active' : ''}`}>
                <BtnDashboard>
                    <img src={users} className='w-6 h-6' />
                    <p>{t("users_tag")}</p>
                </BtnDashboard>
            </li>

        </div>
    );
};

export default AdminList;